import { api } from '@services';

interface IDeleteTask {
  taskId: string;
}

const deleteTask = async ({ taskId }: IDeleteTask): Promise<void> => {
  await api.delete(`/tasks/${taskId}`);
};

export { deleteTask };
